import { Request } from '~src/httpClient/serverApi/requests/Request';
import {
  ExploreContentParams,
  IExploreContentResult
} from '~src/spacesPlatform/serverApi/requests/ExploreContentRequest';

export class GetArchivedContentRequest extends Request<ExploreContentParams, IExploreContentResult> {
  constructor(params: ExploreContentParams) {
    super('getArchivedContentForUser', params);
  }
}